import { Box, Typography } from "@mui/material";
import { ActiveProgramStats } from "common/build/api-parameters/users";
import React from "react";
import { useAuth } from "../../../../../contexts/auth.context";
import { useFetch } from "../../../../../core/components/crud/contexts/fetch.context";
import { SpinWhileFetching } from "../../../../common/SpinWhileFetching";
import { VTextLink } from "../../../../common/VTextLink";
import { SecondaryButton } from "../../../../layout/Button/Button";
import { HeadlineFigureWidget } from "../HeadlineFigureWidget";

export const CollectionHeadlineWidget = (): JSX.Element => {
    const { item } = useFetch<ActiveProgramStats>();
    const { hasPermission } = useAuth();
    const count = item?.collections || 0;
    const hasNoCollections = count === 0;
    return (
        <HeadlineFigureWidget header={"Total Story Collections"}>
            <Box>
                <SpinWhileFetching>
                    <Typography variant="h2">{count}</Typography>
                </SpinWhileFetching>
            </Box>
            <Box>
                {hasPermission("StoryCollectionView") && (
                    <>
                        {hasNoCollections ? (
                            hasPermission("StoryCollectionCreate") && (
                                <VTextLink to="/collections/add">
                                    <SecondaryButton fullWidth>Create Collection</SecondaryButton>
                                </VTextLink>
                            )
                        ) : (
                            <VTextLink to="/collections">
                                <SecondaryButton fullWidth>View Collections</SecondaryButton>
                            </VTextLink>
                        )}
                    </>
                )}
            </Box>
        </HeadlineFigureWidget>
    );
};
